<template>
  <router-link :to="location">
    {{text}}
  </router-link>
</template>

<script>
export default {
  name: 'ContestGroupLink',

  props: {
    contestGroupId: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'group'
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.contestGroupId;

      const loc = {
        name: 'contest_group',
        params: {
          contestId: id.contestId,
          groupId:   id.groupId,
        }
      };

      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const groupIdStr = this.contestGroupId.groupId.toString();

      if(label.length > 0) {
        return label + ' ' + groupIdStr;
      } else {
        return groupIdStr;
      }
    },
  }
};
</script>
